<sfx-navigation-toolbar (closeEvent)="close()">
    <a navigationToolbarButton icon="sf-icon-article" ref=".terms">
        {{ 'Terms' | translate }}
    </a>
    <a navigationToolbarButton icon="sf-icon-privacy" ref=".privacy">
        {{ 'Privacy Policy' | translate }}
    </a>
</sfx-navigation-toolbar>

<sfx-content>
    <sfx-section *ngIf="stateService.is('settings.terms.terms')" disableContentPadding>
        <iframe data-flex src="/terms.html" sandbox="allow-popups allow-scripts" style="border: 0;"></iframe>
    </sfx-section>
    <sfx-section *ngIf="stateService.is('settings.terms.privacy')" disableContentPadding>
        <iframe data-flex src="/privacy.html" sandbox="allow-popups allow-scripts" style="border: 0;"></iframe>
    </sfx-section>
</sfx-content>
